<template>
  <v-dialog v-model="dialog" max-width="647px" persistent>
    <v-card class="create-community-modal" rounded="lg">
      <v-card-title class="headline pb-2">
        {{ $t('broker.clubs.CommunityModal.title') }}
          <v-btn icon class="close-btn" @click="$emit('close')">
            <v-icon>fa-regular fa-xmark</v-icon>
          </v-btn>
      </v-card-title>

      <v-card-text class="px-6 pb-4">
        <p class="subtitle-text mb-3">
          {{ $t('broker.clubs.CommunityModal.subtitle') }}
        </p>
        <p class="note-text">
          {{ $t('broker.clubs.CommunityModal.note') }}
        </p>
      </v-card-text>

      <v-card-actions class="px-6 pb-6 pt-2">
        <v-row no-gutters class="button-row">
          <v-col cols="12" sm="6" class="pr-sm-2">
            <v-btn
              disabled
              large
              rounded
              block
              class="assign-btn"
              height="36"
              @click="selectAssignFlow"
            >
              <v-icon left size="20">fa-regular fa-user</v-icon>
              {{ $t('broker.clubs.CommunityModal.someone') }}
            </v-btn>
          </v-col>
          <v-col cols="12" sm="6" class="pl-sm-2 mt-3 mt-sm-0">
            <v-btn
              large
              rounded
              block
              class="owner-btn"
              height="36"
              @click="selectOwnerFlow"
            >
              <v-icon left size="20">fa-regular fa-user-crown</v-icon>
              {{ $t('broker.clubs.CommunityModal.owner') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'CreateCommunityModal',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    dialog: {
      get() {
        return this.isOpen
      },
      set(value) {
        if (!value) {
          this.$emit('close')
        }
      }
    }
  },
  methods: {
    selectOwnerFlow() {
      this.$emit('owner-flow')
    },
    selectAssignFlow() {
      // Future implementation
      this.$emit('assign-flow')
    }
  }
}
</script>

<style scoped lang="scss">
.create-community-modal {
  background-color: #F8F8F8 !important;
}

.headline {
  position: relative; 
  font-size: 2.5rem !important;
  font-weight: 800 !important;
  line-height: 1.2 !important;
  color: #14161B !important;
  word-break: break-word;
  padding-top: 24px;
  padding-left: 24px;
  padding-right: 24px;
}

.close-btn {
  position: absolute;
  top: 14px;
  right: 14px;
}

.subtitle-text {
  font-size: 1.25rem;
  line-height: 1.5;
  color: #4a4a4a;
  margin-bottom: 0;
}

.note-text {
  font-size: 1rem;
  line-height: 1.4;
  color: #005931;
  font-weight: 500;
  margin-bottom: 0;
}

.button-row {
  width: 100%;
}

.assign-btn {
  background-color: #EBEBEB !important;
  color: #14161B !important;
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0;

  &:hover {
    background-color: #D9D9D9 !important;
  }

  &.v-btn--disabled {
    background-color: #EBEBEB !important;
    color: rgba(20, 22, 27, 0.4) !important;
  }
}

.owner-btn {
  background-color: #28EA96 !important;
  color: #005931 !important;
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0;

  &:hover {
    background-color: #1fd985 !important;
  }
}
</style>
